import type { MigrationStrategies } from 'rxdb';
import type { ViewInspectorDocument } from './viewInspector.types';

export const viewInspectorMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: ViewInspectorDocument) => {
    const newDoc = {
      ...oldDoc,
      clerkName: oldDoc.clerkName || null,
      clerkId: oldDoc.clerkId || null,
      clerkServiceProviderId: oldDoc.clerkServiceProviderId || null,
    };
    return newDoc;
  },
};
